<div dir="ltr">
  <ng-content />
</div>
